module.exports = __webpack_public_path__ + "static/media/solo_hymen3.9534e6a7.svg";